export default __webpack_public_path__ + "static/cruiselogo_disney-725dca4eabc03ee65de0f6c9b27cba93.png";